import React from 'react'
import styles from './MovieFilters.module.scss'

const MovieFilters = ({ filters, onFiltersChange }) => {
  const currentYear = new Date().getFullYear()
  const years = Array.from({ length: 50 }, (_, i) => currentYear - i)
  
  const ratings = [
    { value: '', label: 'Любой рейтинг' },
    { value: '9', label: '9+ звезд' },
    { value: '8', label: '8+ звезд' },
    { value: '7', label: '7+ звезд' },
    { value: '6', label: '6+ звезд' },
    { value: '5', label: '5+ звезд' },
  ]

  const handleFilterChange = (key, value) => {
    onFiltersChange({
      ...filters,
      [key]: value
    })
  }

  const clearFilters = () => {
    onFiltersChange({
      genre: '',
      year: '',
      rating: '',
      search: filters.search // сохраняем поисковый запрос
    })
  }

  const hasActiveFilters = filters.genre || filters.year || filters.rating

  return (
    <div className={styles.movieFilters}>
      <div className={styles.filterGroup}>
        <label className={styles.filterLabel}>Год выпуска</label>
        <select 
          className={styles.filterSelect}
          value={filters.year}
          onChange={(e) => handleFilterChange('year', e.target.value)}
        >
          <option value="">Любой год</option>
          {years.map(year => (
            <option key={year} value={year}>{year}</option>
          ))}
        </select>
      </div>

      <div className={styles.filterGroup}>
        <label className={styles.filterLabel}>Минимальный рейтинг</label>
        <select 
          className={styles.filterSelect}
          value={filters.rating}
          onChange={(e) => handleFilterChange('rating', e.target.value)}
        >
          {ratings.map(rating => (
            <option key={rating.value} value={rating.value}>
              {rating.label}
            </option>
          ))}
        </select>
      </div>

      {hasActiveFilters && (
        <button 
          className={styles.clearButton}
          onClick={clearFilters}
        >
          ✕ Сбросить фильтры
        </button>
      )}
    </div>
  )
}

export default MovieFilters